export function addAsyncActionPostfixes(obj) {
  const postfixes = {
    pending: '_PENDING',
    fulfilled: '_FULFILLED',
    rejected: '_REJECTED'
  };

  const modifiedObj = {};
  Object.keys(obj).forEach((key) => {
    Object.keys(postfixes).forEach((it) => {
      modifiedObj[key + postfixes[it]] = obj[key] + postfixes[it];
    });
  });

  return { ...obj, ...modifiedObj };
}
